import React, { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { PrivateRoute } from "./PrivateRoute";
import SettingRoute from "./SettingRoute";
import PawningWrapper from "../components/pages/pawning/PawningWrapper";
import SchedulePaymentsWrapper from "../components/pages/schedule-payments/SchedulePaymentsWrapper";
import { SchedulePaymentDetails } from "../components/pages/schedule-payments/views/SchedulePaymentDetails";

const DashBoardContainer = lazy(
  () => import("../components/pages/dashboard/DashBoardContainer"),
);
const UserProfile = lazy(
  () => import("../components/pages/profile/views/UserProfile"),
);
const AccountDetailContainer = lazy(
  () => import("../components/pages/account/AccountDetailContainer"),
);
const FixedDeposits = lazy(
  () => import("../components/pages/FixedDeposits/views/FixedDeposits"),
);
const CreditCards = lazy(
  () => import("../components/pages/creditCards/CreditCards"),
);
const CreditCardPaymentWrapper = lazy(
  () =>
    import(
      "../components/pages/bill-payments/views/Creditcard/CreditCardPaymentWrapper"
    ),
);
const Loans = lazy(() => import("../components/pages/loans/Loans"));
const BillPayments = lazy(
  () => import("../components/pages/bill-payments/views/general/BillPayments"),
);
const FundTransferWrapper = lazy(
  () => import("../components/pages/FundTransfer/FundTransferWrapper"),
);
const MyWallet = lazy(() => import("../components/pages/wallet/MyWallet"));
const SettingsWrapper = lazy(
  () => import("../components/pages/settings/SettingsWrapper"),
);
const FavouritesContainer = lazy(
  () => import("../components/pages/favourites/FavouritesContainer"),
);
const ApplicationSettings = lazy(
  () => import("../components/pages/settings/ApplicationSettings"),
);
const History = lazy(() => import("../components/pages/history/history"));
const TransactionDetail = lazy(
  () => import("../components/pages/history/views/TransactionDetail"),
);
const TransferLimitWrapper = lazy(
  () => import("../components/pages/settings/TransferLimitWrapper"),
);
const ChangePasswordWrapper = lazy(
  () => import("../components/pages/settings/ChangePasswordWrapper"),
);
const OTPPreferenceWrapper = lazy(
  () => import("../components/pages/settings/OTPPreferenceWrapper"),
);
const SetDefaultAccount = lazy(
  () => import("../components/pages/settings/SetDefaultAccount"),
);
const AccountNickname = lazy(
  () => import("../components/pages/settings/AccountNickName"),
);
const CreditCardPreferences = lazy(
  () => import("../components/pages/settings/CreditCardPreferences"),
);
const AccountPreferences = lazy(
  () => import("../components/pages/settings/AccountPreferences"),
);
const LeaseWrapper = lazy(
  () => import("../components/pages/Lease/LeaseWrapper"),
);
const PortfolioContainer = lazy(
  () => import("../components/pages/portfolio/PortfolioContainer"),
);
const ServiceRequestMain = lazy(
  () => import("../components/pages/service-reqeust/ServiceRequestMain"),
);

const SecureMailWrapper = lazy(
  () => import("../components/pages/secure-mail/SecureMailWrapper"),
);

const SavingAccountWrapper = lazy(
  () =>
    import(
      "../components/pages/account/SavingsAccountOpening/SavingsAccountWrapper"
    ),
);

const NotificationSettings = lazy(
  () => import("../components/pages/settings/NotificationSettings"),
);

const TrafficFineWrapper = lazy(
  () => import("../components/pages/TrafficFines/TrafficFineWrapper"),
);

const ApplicationRoutes = (props) => {
  return (
    <Suspense fallback={<div></div>}>
      <Routes>
        <Route
          path="dashboard"
          element={<PrivateRoute element={<DashBoardContainer />} />}
        />
        <Route
          path="profile"
          element={<PrivateRoute element={<UserProfile />} />}
        />
        <Route
          path="fixed-deposits"
          element={<PrivateRoute element={<FixedDeposits />} />}
        />
        <Route
          path="settings/application-settings/otp-preference"
          element={
            <PrivateRoute
              element={<SettingRoute element={<OTPPreferenceWrapper />} />}
            />
          }
        />
        <Route
          path="settings/application-settings/change-password"
          element={
            <PrivateRoute
              element={<SettingRoute element={<ChangePasswordWrapper />} />}
            />
          }
        />
        <Route
          path="settings/application-settings"
          element={
            <PrivateRoute
              element={<SettingRoute element={<ApplicationSettings />} />}
            />
          }
        />
        <Route
          path="settings"
          element={<PrivateRoute element={<SettingsWrapper />} />}
        />
        <Route
          path="settings/set-default-account"
          element={<PrivateRoute element={<SetDefaultAccount />} />}
        />
        <Route
          path="accounts"
          element={<PrivateRoute element={<AccountDetailContainer />} />}
        />
        {/* <Route
          path="cards"
          element={<PrivateRoute element={<CreditCards />} />}
        />
        <Route
          path="wallet"
          element={<PrivateRoute element={<MyWallet />} />}
        /> */}
        <Route
          path="fund-transfer"
          element={<PrivateRoute element={<FundTransferWrapper />} />}
        />
        <Route
          path="bill-payments"
          element={<PrivateRoute element={<BillPayments />} />}
        />
        <Route
          path="portfolio"
          element={<PrivateRoute element={<PortfolioContainer />} />}
        />
        <Route
          path="credit-cards-bill-settle"
          element={<PrivateRoute element={<CreditCardPaymentWrapper />} />}
        />
        <Route path="loans" element={<PrivateRoute element={<Loans />} />} />
        <Route
          path="lease"
          element={<PrivateRoute element={<LeaseWrapper />} />}
        />
        <Route
          path="favourites"
          element={<PrivateRoute element={<FavouritesContainer />} />}
        />
        <Route
          path="history"
          element={<PrivateRoute element={<History />} />}
        />
        <Route
          path="history/:id"
          element={<PrivateRoute element={<TransactionDetail />} />}
        />
        <Route
          path="settings/transfer-limit-preference"
          element={<PrivateRoute element={<TransferLimitWrapper />} />}
        />
        <Route
          path="settings/account-nickname"
          element={<PrivateRoute element={<AccountNickname />} />}
        />
        <Route
          path="settings/credit-card-preferences"
          element={<PrivateRoute element={<CreditCardPreferences />} />}
        />
        <Route
          path="settings/account-preferences"
          element={<PrivateRoute element={<AccountPreferences />} />}
        />
        <Route
          path="more-services"
          element={<PrivateRoute element={<ServiceRequestMain />} />}
        />
        <Route
          path="secure-mail"
          element={<PrivateRoute element={<SecureMailWrapper />} />}
        />
        <Route
          path="secure-mail/:id"
          element={<PrivateRoute element={<SecureMailWrapper />} />}
        />
        <Route
          path="settings/notification-settings"
          element={<PrivateRoute element={<NotificationSettings />} />}
        />

        {/* <Route
          path="savings-account-opening"
          element={<PrivateRoute element={<SavingAccountWrapper />} />}
        /> */}

        <Route
          path="pawning"
          element={<PrivateRoute element={<PawningWrapper />} />}
        />

        <Route
          path="schedule-payments"
          element={<PrivateRoute element={<SchedulePaymentsWrapper />} />}
        />

        <Route
          path="schedule-payment-details"
          element={<PrivateRoute element={<SchedulePaymentDetails />} />}
        />

        {/* <Route
          path="traffic-fines"
          element={<PrivateRoute element={<TrafficFineWrapper />} />}
        /> */}

        <Route path="*" element={<Navigate to="/app/dashboard" replace />} />
      </Routes>
    </Suspense>
  );
};

export { ApplicationRoutes };
